import module from 'module';
import $ from 'jquery';

import templateUrl from './stocked-item-reservation-receipt-view.template.html';
import './stocked-item-reservation-receipt-view.style.less';

class StockedItemReservationReceiptViewComponent {
  constructor($route, $location, http, printService, $timeout) {
    this.$route = $route;
    this.$location = $location;
    this.http = http;
    this.printService = printService;
    this.$timeout = $timeout;
  }

  $onInit() {
    const itemId = this.$route.current.params['itemId'];
    this.$timeout(() => {
      this.http.post(`/print/STOCKED_ITEM_RESERVATION_RECEIPT/json`, {itemId: itemId}).success(doc => {
        this.doc = doc;

        return this.printService.printToContainer(doc, {
          autoPrint: false,
          backgroundEnabled: true,
          container: $('.iframe-preview')
        });
      });
    });
  }

  redirectBack() {
    const customerId = this.$route.current.params.customerId;
    this.$location.path(`/customer/${customerId}/stocked-items`);
  }

  print() {
    this.printService.printToContainer(this.doc, {
      autoPrint: true,
      backgroundEnabled: false,
      container: $('.iframe-invisible')
    });
  }
}

module.component('stockedItemReservationReceiptView', {
  templateUrl: templateUrl,
  controller: StockedItemReservationReceiptViewComponent
});